import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import StatusPage from '../components/StatusPage';

const waiting = 'Open the confirmation email from First 1000. If it isn’t in your inbox, check spam or promotions.';

export default function Verify() {
  const id = new URLSearchParams(useLocation().search).get('id');
  const [message, setMessage] = useState(waiting);
  useEffect(() => {
    if (!id) return;
    let timer, stopped = false, count = 0;
    const controller = new AbortController();
    async function poll() {
      count += 1;
      try {
        const response = await fetch('/api/isVerifiedUser', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id}), signal:controller.signal });
        if (!response.ok) throw new Error('unavailable');
        const data = await response.json();
        if (stopped) return;
        if (data.verified === true || data.verified === 'true') { window.location.href = 'https://first1000.substack.com'; return; }
        if (data.verified !== false && data.verified !== 'false') throw new Error('unavailable');
        setMessage(waiting);
      } catch (error) {
        if (stopped) return;
        setMessage('We couldn’t check your confirmation yet. We’ll try again automatically.');
      }
      if (count < 300) timer = setTimeout(poll, 1000);
      else setMessage('Still waiting for confirmation. Open the link in your email to finish.');
    }
    poll();
    return () => { stopped = true; clearTimeout(timer); controller.abort(); };
  }, [id]);
  return <StatusPage title="Check your inbox." message={message}/>;
}
